document.addEventListener("DOMContentLoaded", function() {

  function initializeProductVideos() {
    // Select all videos inside product media items
    const videos = document.querySelectorAll('.product__media-item video');

    videos.forEach(video => {
      // Skip if already initialized
      if (video.dataset.singleClickInit) return;
      video.dataset.singleClickInit = true;

      // Ensure mobile autoplay works
      video.muted = true;
      video.playsInline = true;

      // Find overlay if it exists
      const wrapper = video.closest('.product__media-item');
      const overlay = wrapper ? wrapper.querySelector('.deferred-media__poster-button') : null;

      if (overlay) {
        overlay.addEventListener('click', function() {
          video.play();
          overlay.style.transition = 'opacity 0.3s';
          overlay.style.opacity = '0';
          setTimeout(() => { overlay.style.display = 'none'; }, 300);
        });
      } else {
        // If no overlay, clicking video itself plays immediately
        video.addEventListener('click', function() {
          if (video.paused) video.play();
        });
      }
    });
  }

  // Initial run
  initializeProductVideos();

  // Run again after 1s to catch any lazy-loaded videos (like carousels)
  setTimeout(initializeProductVideos, 1000);
});

